import React from 'react';
import { connect } from 'react-redux';
import { ErrorModal } from '../components/modals/error-modal';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'printLabelPrintWarning.title',
    defaultMessage: 'Print Warning',
    id: 'hSbf1o',
  },
  message: {
    description: 'printLabelPrintWarning.message',
    defaultMessage: 'This label has already been printed. Reprint anyway?',
    id: 'YzJOs8',
  },
  cancel: {
    description: 'printLabelPrintWarning.cancel',
    defaultMessage: 'Cancel',
    id: 'r8L3Rb',
  },
  yes: {
    description: 'printLabelPrintWarning.yes',
    defaultMessage: 'Yes, Reprint',
    id: 'zdLG/L',
  },
});

const mapStateToProps = (state, props) => {
  const { modalFrameworkMethods } = props;
  return {
    modalFrameworkMethods,
    state: 'warning',
    title: <FormattedMessage {...messages.title} />,
    message: <FormattedMessage {...messages.message} />,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const { action, onYesClick } = props;
  return {
    buttons: [
      {
        children: <FormattedMessage {...messages.cancel} />,
      },
      {
        theme: 'primary',
        children: <FormattedMessage {...messages.yes} />,
        onClick:
          onYesClick ||
          (() => {
            dispatch({ ...action, override: true });
          }),
      },
    ],
  };
};

export const PrintLabelPrintWarningContainer = connect(mapStateToProps, mapDispatchToProps)(ErrorModal);
